import { useAuth } from '@clerk/clerk-react'
import { useMemo } from 'react'
import { createApiFetcher } from '@/lib/api'

/**
 * React hook that returns an authenticated API fetcher.
 * Must be used within a ClerkProvider.
 */
export function useApi() {
  const { getToken } = useAuth()
  return useMemo(() => createApiFetcher(getToken), [getToken])
}
